import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { routes } from '../../../constants/routes.constants'

class PartnerPageComponent extends React.Component {
	componentWillMount() {
		const { history } = this.props
		history.replace(`${routes.PARCEIRO}/extrato-de-pontos`)
	}

	render() {
		return <span>rota privada parceiro</span>
	}
}

const connectedPartnerPageComponent = withRouter(
	connect(null)(PartnerPageComponent)
)

export { connectedPartnerPageComponent as ModuleRootComponent }
